// extracted by mini-css-extract-plugin
module.exports = {"facetActions":"KW","done":"LW","disabled":"MW","resetFacets":"NW"};